/**
 * Lazy loader for AWS RUM. Import this instead of aws-rum so the aws-rum-web
 * bundle is not in the main chunk.
 */

export type AwsRumInstance = {
  recordError?(error: unknown): void;
};

let instance: AwsRumInstance | null | undefined = undefined;

export function getAwsRum(): Promise<AwsRumInstance | null> {
  if (instance !== undefined) {
    return Promise.resolve(instance);
  }
  return import("./aws-rum").then((m) => {
    instance = m.awsRum ?? null;
    return instance;
  });
}
